import { render } from "./DayMenuButtons.vue?vue&type=template&id=72b73d9f&scoped=true&ts=true"
import script from "./DayMenuButtons.vue?vue&type=script&lang=ts"
export * from "./DayMenuButtons.vue?vue&type=script&lang=ts"

import "./DayMenuButtons.vue?vue&type=style&index=0&id=72b73d9f&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b73d9f"]])

export default __exports__